/*
 * Vylevo motion.
 *
 * Reveals content as it scrolls into view and triggers the icon "buzz".
 * Only elements that start below the fold are ever hidden, and the hiding
 * class is added by this script itself, so a slow or failed script can
 * never leave content invisible. Skipped entirely in the theme editor and
 * for visitors who prefer reduced motion.
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // [selector, stagger between siblings in seconds]
  var REVEAL_GROUPS = [
    ['.title-wrapper-with-link, .multicolumn-text', 0],
    ['.multicolumn-list__item', 0.1],
    ['.content-and-comparison-table', 0],
    ['.plan-card', 0.12],
    ['.collapsible-content .accordion', 0.06],
    ['.rich-text__blocks', 0]
  ];

  var MAX_STAGGER = 0.5;
  var REVEAL_MS = 700;

  function startsOffscreen(el) {
    return el.getBoundingClientRect().top > window.innerHeight * 0.92;
  }

  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      revealObserver.unobserve(el);
      el.classList.add('vy-in');

      // Hand the element back to the theme's own styles once it has settled,
      // so hover transforms (e.g. pricing cards) are not overridden.
      var delay = parseFloat(el.style.getPropertyValue('--vy-delay')) || 0;
      setTimeout(function () {
        el.classList.remove('vy-reveal', 'vy-in');
        el.style.removeProperty('--vy-delay');
      }, delay * 1000 + REVEAL_MS + 150);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  REVEAL_GROUPS.forEach(function (group) {
    var stagger = group[1];
    var indexByParent = new Map();

    document.querySelectorAll(group[0]).forEach(function (el) {
      if (!startsOffscreen(el)) return;

      var i = indexByParent.get(el.parentElement) || 0;
      indexByParent.set(el.parentElement, i + 1);

      if (stagger) {
        el.style.setProperty('--vy-delay', Math.min(i * stagger, MAX_STAGGER) + 's');
      }
      el.classList.add('vy-reveal');
      revealObserver.observe(el);
    });
  });

  // Comparison table: ticks/crosses pop in row by row.
  document.querySelectorAll('.comparison-table').forEach(function (table) {
    if (!startsOffscreen(table)) return;

    table.querySelectorAll('.comparison-table__checkmark, .comparison-table__x')
      .forEach(function (mark, i) {
        mark.style.setProperty('--vy-delay', (0.15 + i * 0.08) + 's');
      });
    table.classList.add('vy-table-ready');

    var tableObserver = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      tableObserver.disconnect();
      table.classList.add('vy-in');
      setTimeout(function () {
        table.classList.remove('vy-table-ready', 'vy-in');
      }, 2500);
    }, { threshold: 0.3 });

    tableObserver.observe(table);
  });

  // Icons buzz, one after another, the first time their row is seen.
  // Buzzing never hides anything, so above-the-fold icons are included.
  var buzzObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      buzzObserver.unobserve(entry.target);

      var icons = entry.target.querySelectorAll('.icon-bar-card__icon');
      icons.forEach(function (icon, i) {
        setTimeout(function () {
          icon.classList.add('vy-buzz');
          setTimeout(function () { icon.classList.remove('vy-buzz'); }, 1000);
        }, 350 + i * 180);
      });
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('.multicolumn-list').forEach(function (list) {
    if (list.querySelector('.icon-bar-card__icon')) buzzObserver.observe(list);
  });
})();
